import IntegrationHeader from "./components/IntegrationHeader";
import ServicesSection from "./components/ServicesSection";
import TrackingStatus from "./components/TrackingStatus";
import Webhooks from "./components/Webhooks";
import useIntegration from "./hooks/useIntegration";

export default function Integration() {
  const { openCourier, loading } = useIntegration();
  if (loading) {
    return (
      <div className="border rounded p-4 md:px-7 md:py-5">
        <IntegrationHeader />
        <div className="animate-pulse space-y-4 w-full md:w-1/2">
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
        </div>
      </div>
    )
  }

  return (
    <div className="border rounded p-4 md:px-7 md:py-5">
      <IntegrationHeader />
      <ServicesSection openCourierId={openCourier?.id} services={openCourier?.services || []} />
      <Webhooks 
        authToken={openCourier?.webhookAuthToken}
        openCourierId={openCourier?.id}
        ratesUrl={openCourier?.getRatesUrl}
        createShipmentUrl={openCourier?.createShipmentUrl}
        cancelShipmentUrl={openCourier?.cancelShipmentUrl}
      />
      <TrackingStatus
        authToken={openCourier?.clientAuthToken}
        openCourierId={openCourier?.id}
      />
    </div>
  )
}
